import { inject, PLATFORM_ID, provideAppInitializer } from '@angular/core';
import { UtmService } from '../services/utm/utm.service';
import { UtmStorageService } from '../services/utm-storage/utm-storage.service';
import { isPlatformBrowser } from '@angular/common';

export function provideStoreUtmParams() {
  return provideAppInitializer(() => {
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
      return;
    }

    const utmStorageService = inject(UtmStorageService);
    const utmService = inject(UtmService);

    utmStorageService.remove();

    const utmParams = utmService.getUtmQueryParamsFromUrl();

    if (Object.keys(utmParams).length > 0) {
      utmStorageService.set(utmParams);
    }
  });
}
